const loadConfig = async <T>(url: string): Promise<T> => {
  try {
    const response = await fetch(url);

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    return await response.json() as T;
  } catch (error) {
    console.error('Error loading config:', error);
    throw error;
  }
};

export default loadConfig;
